module.exports = __webpack_public_path__ + "img/close_btn.0c6f9085.svg";